export const enumerable = (target, name, desc) => {
    if (desc) {
        desc.enumerable = true;
        return desc;
    }
    Object.defineProperty(target, name, {
        set(value) {
            Object.defineProperty(this, name, {
                value, enumerable: true, writable: true, configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
};
//# sourceMappingURL=enumerable.js.map